import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postNewInvoice } from 'api';

// Then, handle actions in your reducers:
const newInvoiceSlice = createSlice({
  name: 'newInvoice',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    newInvoicePostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    newInvoicePostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    newInvoicePostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    newInvoicePostFormReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  newInvoicePostStart,
  newInvoicePostSuccess,
  newInvoicePostFail,
  newInvoicePostFormReset,
} = newInvoiceSlice.actions;

// The reducer
export const newInvoiceReducer = newInvoiceSlice.reducer;

// Asynchronous thunk action
export const newInvoicePost = (formData) => (dispatch) => {
  dispatch(newInvoicePostStart());

  postNewInvoice(formData)
    .then((payload) => {
      dispatch(newInvoicePostSuccess(payload));
    })
    .catch((error) => {
      dispatch(newInvoicePostFail(error));
    });
};
